<template>
  <div class="main-uc-pop-over">
    <!-- <f7-block-title>
      {{ title }}
    </f7-block-title> -->
    <div
      v-if="title"
      class="title-pop-over"
    >
      <span> {{ title }}</span>
    </div>
    <f7-button
      fill
      :popover-open="`.pop-over-menu-${id}`"
      class="pop-over-button"
      :class="{ 'disabled-component': disabled }"
      @click="popoverSortIsOpened = true"
    >
      <span>
        {{ sortFieldSelected.length > 0 ? sortFieldSelected : props.defaultValue ?? props.emptyTitle }}
      </span>
      <img
        class="main-uc-pop-over__img--search"
        src="@/static/icons/ns_ic_sort.svg"
      >
    </f7-button>

    <div v-if="!disabled">
      <f7-popover
        v-model:opened="popoverSortIsOpened"
        :class="`pop-over-menu-${id}`"
      >
        <f7-list>
          <f7-list-item
            v-for="(filterElement, i) in enhancedSortFieldList"
            :key="i"
            link="#"
            popover-close
            chevron
            @click="changeSortElement(filterElement)"
          >
            {{ filterElement }}
          </f7-list-item>
        </f7-list>
        <slot />
      </f7-popover>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { computed, ref, useId } from 'vue';

const props = defineProps({
  sortFieldList: {
    type: /** @type {import('vue').PropType<any[]>} */ (Array),
    default: () => [],
  },

  defaultValue: {
    type: String,
    default: null,
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  title: {
    type: String,
    default: '',
  },

  emptyTitle: {
    type: String,
    default: 'TODOS',
  },

  // Cuando no se tiene elegir una opcion, se mostrará la opcion de 'TODOS'
  optionAll: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['change-element']);

const popoverSortIsOpened = ref(false);
const sortFieldSelected = ref('');

const id = useId();

const enhancedSortFieldList = computed(() => {
  if (props.optionAll) return [...props.sortFieldList, 'TODOS'];
  return [...props.sortFieldList];
});

/**
 * Handles the element selection.
 * @param {string} val - The entity value.
 */
function changeSortElement(val) {
  if (val) {
    sortFieldSelected.value = val;
    emit('change-element', val);
  }
}

defineExpose({
  changeSortElement,
});
</script>

<style scoped lang="scss">
.main-uc-pop-over {
  --f7-block-margin-vertical: 15px;
  --f7-block-padding-horizontal: 16px;

  .title-pop-over {
    font-size: var(--popover-title-font-size);
    color: var(--popover-title-color);
    line-height: var(--popover-title-line-height);
    margin: var(--popover-title-margin);
  }

  .pop-over-button {
    padding: 0 5px;
    background-color: var(--popover-btn-bg-color);
    color: var(--popover-btn-color);
    height: var(--popover-btn-height);
    font-weight: 400;
    justify-content: space-between;
    border: var(--popover-btn-border);
    border-radius: var(--popover-btn-border-radius);
  }
}
</style>
